import type { ApiConfig } from '../../types'

export const capitalHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 100, // 最新100件ずつ（deposit/withdrawal それぞれ）
  order: 'desc', // 新しい順に取得
  range: undefined,
  requiresRange: false,
  type: 'capital-history',
} as const satisfies ApiConfig
